import {
    FETCH_ROLES_START,
    FETCH_ROLES_SUCCESS,
    FETCH_ROLES_ERROR
} from '../../actions/common/rolesAction';

const INIT_STATE = {
    error: "",
    loading: false,
    message: '',
    roles: JSON.parse(localStorage.getItem('roles')) || []
};

const rolesReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case FETCH_ROLES_START: {
            return { ...state, error: '', message: '', loading: true };
        }
        case FETCH_ROLES_SUCCESS: {
            return { ...state, error: '', message: '', loading: false, roles: action.roles };
        }
        case FETCH_ROLES_ERROR: {
            return { ...state, loading: false, error: action.error, message: '' };
        }
        default:
            return state;
    }
}

export default rolesReducer;
